{
  "name": "ikp-frontends",
  "version": "berater-v1.19.0-rc35",
  "packageManager": "pnpm@11.13.1",
  "engines": {
    "pnpm": "11.13.1",
    "node": ">=24.0.0"
  },
  "projects": {
    "ikp": "apps/ikp",
    "ikp-berater": "apps/ikp-berater"
  },
  "scripts": {
    "ng": "nx",
    "reset": "nx reset",
    "start": "nx serve",
    "start:expose-host": "nx serve --host 0.0.0.0",
    "ikp": "pnpm nx run ikp:serve:local",
    "berater": "pnpm nx run ikp-berater:serve:local",
    "build": "pnpm nx build",
    "test": "pnpm nx run-many --target=test --all",
    "analyze": "ng build --prod --stats-json && webpack-bundle-analyzer dist/ikp/stats.json",
    "full-test": "pnpm run test && pnpm nx run-many --target=e2e --all",
    "prepare": "husky",
    "parse-version": "node parse-version.js",
    "csp:test": "pnpm run csp:test:ikp && pnpm run csp:test:berater",
    "csp:test:ikp": "node scripts/csp/test-csp.mjs --app ikp",
    "csp:test:berater": "node scripts/csp/test-csp.mjs --app ikp-berater",
    "fork-sync": "node scripts/fork-sync/fork-sync.mjs",
    "fork-sync-finalize": "node scripts/fork-sync/fork-sync.mjs finalize"
  },
  "private": true,
  "dependencies": {
    "@aarsteinmedia/dotlottie-player": "^6.3.11",
    "@angular-architects/ngrx-toolkit": "^21.0.1",
    "@angular/animations": "21.2.21",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.21",
    "@angular/compiler": "21.2.21",
    "@angular/core": "21.2.21",
    "@angular/forms": "21.2.21",
    "@angular/localize": "21.2.21",
    "@angular/platform-browser": "21.2.21",
    "@angular/platform-browser-dynamic": "21.2.21",
    "@angular/router": "21.2.21",
    "@angular/service-worker": "21.2.21",
    "@azure/msal-angular": "^5.2.4",
    "@azure/msal-browser": "^5.10.1",
    "@editorjs/editorjs": "^2.31.6",
    "@editorjs/list": "^2.0.9",
    "@editorjs/paragraph": "^2.11.7",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@fortawesome/fontawesome-pro": "6.7.2",
    "@fortawesome/fontawesome-svg-core": "6.7.2",
    "@fortawesome/free-solid-svg-icons": "6.7.2",
    "@ng-bootstrap/ng-bootstrap": "20.0.0",
    "@ng-doc/app": "21.1.0",
    "@ng-doc/builder": "21.1.0",
    "@ng-doc/core": "21.1.0",
    "@ng-doc/ui-kit": "21.1.0",
    "@ngrx/operators": "^21.1.1",
    "@ngrx/signals": "21.1.1",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@nx/devkit": "22.7.7",
    "@piwikpro/ngx-piwik-pro": "^2.6.0",
    "@popperjs/core": "^2.11.8",
    "angular-oauth2-oidc": "^20.0.2",
    "bootstrap": "^5.3.8",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-annotation": "^3.1.0",
    "data-forge": "^1.10.5",
    "dayjs": "^1.11.21",
    "deep-object-diff": "^1.1.9",
    "dotenv": "^17.4.2",
    "editorjs-drag-drop": "^1.1.16",
    "editorjs-header-with-anchor": "^2.6.0",
    "ibantools": "^4.5.4",
    "js-cookie": "^3.0.8",
    "jsoneditor": "^10.4.3",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.4",
    "my-ua-parser": "^2.0.4",
    "ng2-charts": "^10.0.0",
    "ngx-webstorage": "21.0.1",
    "qr-code-styling": "^1.9.2",
    "rxjs": "7.8.2",
    "short-unique-id": "^5.3.2",
    "swiper": "^12.2.0",
    "tslib": "^2.8.1",
    "valibot": "^1.4.2",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.21",
    "@angular-devkit/core": "21.2.21",
    "@angular-devkit/schematics": "21.2.21",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular-eslint/utils": "22.0.0",
    "@angular/cli": "21.2.21",
    "@angular/compiler-cli": "21.2.21",
    "@angular/language-service": "21.2.21",
    "@cucumber/cucumber": "^13.2.0",
    "@eslint/eslintrc": "^3.3.5",
    "@eslint/js": "~9.39.2",
    "@ng-web-apis/common": "^5.3.0",
    "@nx/angular": "22.7.7",
    "@nx/cypress": "22.7.7",
    "@nx/eslint": "22.7.7",
    "@nx/eslint-plugin": "22.7.7",
    "@nx/jest": "22.7.7",
    "@nx/js": "22.7.7",
    "@nx/playwright": "22.7.7",
    "@nx/plugin": "22.7.7",
    "@nx/web": "22.7.7",
    "@nx/workspace": "22.7.7",
    "@openapitools/openapi-generator-cli": "^2.39.1",
    "@playwright/test": "^1.61.1",
    "@schematics/angular": "21.2.21",
    "@swc-node/register": "1.11.1",
    "@swc/core": "1.15.33",
    "@swc/helpers": "^0.5.21",
    "@types/dom-speech-recognition": "^0.0.12",
    "@types/jest": "30.0.0",
    "@types/js-cookie": "^3.0.6",
    "@types/jsoneditor": "^9.9.6",
    "@types/node": "25.9.3",
    "@typescript-eslint/eslint-plugin": "8.61.0",
    "@typescript-eslint/utils": "8.61.0",
    "angular-eslint": "21.4.0",
    "baseline-browser-mapping": "2.11.1",
    "command-line-args": "^6.0.2",
    "cypress": "15.19.0",
    "default-composer": "^0.6.0",
    "dpdm": "^4.0.1",
    "esbuild": "^0.28.1",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-json-merge": "^0.1.0",
    "eslint": "9.39.2",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "6.4.3",
    "eslint-plugin-import": "~2.32.0",
    "eslint-plugin-json": "^4.0.1",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-sonarjs": "^4.2.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.6.0",
    "husky": "^9.1.7",
    "jasmine-core": "6.3.0",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "30.4.2",
    "jest-canvas-mock": "^2.5.2",
    "jest-environment-jsdom": "30.4.1",
    "jest-fail-on-console": "^3.3.4",
    "jest-jasmine2": "30.4.2",
    "jest-junit": "^17.0.0",
    "jest-preset-angular": "17.0.0",
    "jest-sonar-reporter": "^2.0.0",
    "jest-util": "30.4.1",
    "jsonc-eslint-parser": "^3.1.0",
    "lint-staged": "^17.0.7",
    "mockdate": "^3.0.5",
    "ng-mocks": "^14.15.2",
    "ng-packagr": "21.2.5",
    "nx": "22.7.7",
    "object-code": "^2.0.0",
    "playwright-bdd": "^9.2.0",
    "prettier": "^3.8.3",
    "selenium-webdriver": "^4.46.0",
    "sonar-scanner": "^3.1.0",
    "ts-jest": "29.4.9",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.61.0"
  },
  "jestSonar": {
    "reportPath": "target/test-results/jest",
    "reportFile": "TESTS-results-sonar.xml"
  }
}
